import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BankTransferDisplayForm.scss'
import Alert from 'components/Alert'

class BankAccountForm extends Component {
    static propTypes = {
      bankTransferForm: PropTypes.object.isRequired,
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
      bankTransfers: PropTypes.instanceOf(Array),
    }

    render() {
      const {
        bankTransferForm, schema, form, handleChange, handleValidation, handleFocus,
      } = this.props
      console.log('bankTransferForm', form)
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.toAccountName}
              error={form.toAccountName.error}
              handleChange={handleChange}
              label="Account Name"
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountName.value}
              valid={form.toAccountName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankBSB}
              error={form.bankBSB.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankBSB.value}
              valid={form.bankBSB.valid}
            />
          </li>
          {bankTransferForm.BankName &&
          <li><div>
            <Alert type="info">
              <b>Bank details</b><br />
              {`Name: ${bankTransferForm.BankName}`}<br />
              {`Address: ${bankTransferForm.BankAddress}, ${bankTransferForm.BankCity}, ${bankTransferForm.BankState}, ${bankTransferForm.BankCountry}, ${bankTransferForm.BankZip}`}
            </Alert>
          </div></li>
            }
          {!bankTransferForm.BankName &&
          <div>
            <Alert type="error">No bank entered, please enter a valid BSB No</Alert></div>
            }
          <li>
            <TextInput
              {...schema.toAccountNumber}
              error={form.toAccountNumber.error}
              handleChange={handleChange}
              label="Account Number"
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountNumber.value}
              valid={form.toAccountNumber.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.amount}
              error={form.amount.error}
              handleChange={handleChange}
              label="Amount $"
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.amount.value}
              valid={form.amount.valid}
            />
          </li></div>
      )
    }
}

export default BankAccountForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/BankAccountForm.js